import { render, staticRenderFns } from "./AppNavbarVerticalLayout.vue?vue&type=template&id=a4882060&scoped=true&"
import script from "./AppNavbarVerticalLayout.vue?vue&type=script&lang=js&"
export * from "./AppNavbarVerticalLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppNavbarVerticalLayout.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AppNavbarVerticalLayout.vue?vue&type=style&index=1&id=a4882060&scoped=true&lang=css&"
import style2 from "./AppNavbarVerticalLayout.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4882060",
  null
  
)

export default component.exports